// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicMyHomeV1GetGeocodeRequest,
  TPublicMyHomeV1GetGeocodeModel,
  IMappers,
  TPublicMyHomeV1GetGeocodeResponse,
  IPublicMyHomeV1GetGeocodeResponse,
  IPublicMyHomeV1GetGeocodeResponseError,
} from './types';

export const defaultConfig: TPublicMyHomeV1GetGeocodeModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'newbuilding-estimate',
  pathApi: '/my-home/v1/get-geocode/',
} as TPublicMyHomeV1GetGeocodeModel;

export function createPublicMyHomeV1GetGeocodeModel(
  parameters: IPublicMyHomeV1GetGeocodeRequest,
): TPublicMyHomeV1GetGeocodeModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicMyHomeV1GetGeocodeOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeV1GetGeocodeRequest;
}

export async function fetchPublicMyHomeV1GetGeocode<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV1GetGeocodeOptions<TResponse200, TResponse400>): Promise<
  TPublicMyHomeV1GetGeocodeResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicMyHomeV1GetGeocodeModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicMyHomeV1GetGeocodeResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicMyHomeV1GetGeocodeResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicMyHomeV1GetGeocodeResponse;
}
